import React, { useState } from 'react';
import { projectImages } from '../data/mockData';
import ImageLightbox from '../components/ImageLightbox';

const Gallery = () => {
  const [filter, setFilter] = useState('all');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const categories = [
    { value: 'all', label: 'All Projects' },
    { value: 'pool-fencing', label: 'Pool Fencing' },
    { value: 'balustrade', label: 'Balustrades' },
    { value: 'fencing', label: 'Fencing' },
    { value: 'shower', label: 'Shower Screens' }
  ];

  const filteredImages = filter === 'all' 
    ? projectImages 
    : projectImages.filter(img => img.category === filter);

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <div className="gallery-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-hero-title">Project Gallery</h1>
          <p className="page-hero-subtitle">
            Explore our portfolio of completed glass installations across Sydney
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          {/* Filter Buttons */}
          <div className="gallery-filters">
            {categories.map((category) => (
              <button
                key={category.value}
                className={`filter-btn ${filter === category.value ? 'active' : ''}`}
                onClick={() => setFilter(category.value)}
              >
                {category.label}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="gallery-grid-masonry">
            {filteredImages.map((image, index) => (
              <div
                key={image.id}
                className="gallery-item-large"
                onClick={() => openLightbox(index)}
              >
                <img src={image.url} alt={image.title} />
                <div className="gallery-item-overlay">
                  <h3>{image.title}</h3>
                  <p>{image.description}</p>
                </div>
              </div>
            ))}
          </div>

          {filteredImages.length === 0 && (
            <div className="no-results">
              <p>No projects found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Gallery Info */}
      <section className="gallery-info-section">
        <div className="container">
          <div className="gallery-info-card">
            <h2>Need More Inspiration?</h2>
            <p>
              These are just a few examples of our work. Each project is unique and tailored to our clients' specific requirements. 
              Contact us to discuss your vision and see how we can bring it to life.
            </p>
            <p className="info-note">
              <strong>Note:</strong> All projects are completed to Australian safety standards with premium materials and professional installation.
            </p>
          </div>
        </div>
      </section>

      {lightboxOpen && (
        <ImageLightbox
          images={filteredImages}
          initialIndex={lightboxIndex}
          onClose={() => setLightboxOpen(false)}
        />
      )}
    </div>
  );
};

export default Gallery;
